import '../styles/footer.css';


const Footer= () => {
  

  return (
    <footer>
      <div>
        <a href="https://www.facebook.com" rel="noreferrer" target="_blank"><i className="fab fa-facebook-f"></i></a>
        <a href="https://www.instagram.com" rel="noreferrer" target="_blank"><i className="fab fa-instagram"></i></a>
        <a href="https://twitter.com" rel="noreferrer" target="_blank"><i className="fab fa-twitter"></i></a>
        <a href="https://pinterest.com" rel="noreferrer" target="_blank"><i className="fab fa-pinterest"></i></a>
        <a href="https://www.youtube.com" rel="noreferrer" target="_blank"><i className="fab fa-youtube"></i></a>
      </div>
      <div>
        <p>Copyright &copy; 2022 Wiola Polok www.u-v.codes. All Rights Reserved</p>
      </div>
    </footer>
  );
}

export default Footer;